module.exports = __webpack_public_path__ + "static/NotoSerif-ad39bb34573691539b96d39aac7b5a08.woff2";